export const JS_DATE_FORMAT = "dd MMM yyyy";
export const MOMENT_DISP_DATE_FORMAT = "DD MMM YYYY";
export const MOMENT_DISP_DATE_TIME_FORMAT = "DD MMM YYYY HH:mm";